import { IUserProfile, IPlanningConfiguration } from '@/interfaces';
import { MainState, AppNotification } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
  setToken(state: MainState, payload: string) {
    state.token = payload;
  },
  setLoggedIn(state: MainState, payload: boolean) {
    state.isLoggedIn = payload;
  },
  setLogInError(state: MainState, payload: boolean) {
    state.logInError = payload;
  },
  setLogInAccountLocked(state: MainState, payload: boolean) {
    state.logInAccountLocked = payload;
  },
  setInactivityLocked(state: MainState, payload: boolean) {
    state.inactivityLocked = payload;
  },
  setUserProfile(state: MainState, payload: IUserProfile) {
    state.userProfile = payload;
  },
  setPlanningConfiguration(state: MainState, payload: IPlanningConfiguration) {
    state.planningConfiguration = payload;
  },
  setCalendars(state: MainState, payload: string[]) {
    state.calendars = payload;
  },
  setPhysiotherapyUsers(state: MainState, payload: IUserProfile[]) {
    state.physiotherapyUsers = payload;
  },
  setDashboardMiniDrawer(state: MainState, payload: boolean) {
    state.dashboardMiniDrawer = payload;
    try {
      localStorage.setItem('sophia.drawerPinned', String(!payload));
    } catch {
      // storage unavailable (private mode); the preference just isn't remembered
    }
  },
  setDashboardShowDrawer(state: MainState, payload: boolean) {
    state.dashboardShowDrawer = payload;
  },
  addNotification(state: MainState, payload: AppNotification) {
    state.notifications.push(payload);
  },
  removeNotification(state: MainState, payload: AppNotification) {
    state.notifications = state.notifications.filter((notification) => notification !== payload);
  },
};

const {commit} = getStoreAccessors<MainState | any, State>('');

export const commitSetDashboardMiniDrawer = commit(mutations.setDashboardMiniDrawer);
export const commitSetDashboardShowDrawer = commit(mutations.setDashboardShowDrawer);
export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLogInError = commit(mutations.setLogInError);
export const commitSetLogInAccountLocked = commit(mutations.setLogInAccountLocked);
export const commitSetInactivityLocked = commit(mutations.setInactivityLocked);
export const commitSetToken = commit(mutations.setToken);
export const commitSetUserProfile = commit(mutations.setUserProfile);
export const commitSetPlanningConfiguration = commit(mutations.setPlanningConfiguration);
export const commitSetCalendars = commit(mutations.setCalendars);
export const commitSetPhysiotherapyUsers = commit(mutations.setPhysiotherapyUsers);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
